// Mind2Magic CRM — Calendar, Tareas, Comentarios & Cotizaciones Module
// Extracted from index.html Step 12.

import { STAGES, TYPE_LABELS } from './constants.js'
import { store } from './store.js'
import { supabaseDB } from './supabase/db.js'

// ========== CALENDARIO ==========
let calCurrentDate = new Date()
// Expose on window so showView() in inline script can reset it
Object.defineProperty(window, 'calendarSearchQuery', {
    get() { return store.calendarSearchQuery },
    set(v) { store.calendarSearchQuery = v },
    configurable: true
})

function calNavMonth(delta) {
    calCurrentDate.setMonth(calCurrentDate.getMonth() + delta)
    renderCalendario()
}

function calGoToday() {
    calCurrentDate = new Date()
    renderCalendario()
}

function getCalendarEvents() {
    const { leads, historico, settings, defaultSettings } = store
    const events = []
    const showViajeInicio = document.getElementById('calFilterViajeInicio')?.checked !== false
    const showViajeFin = document.getElementById('calFilterViajeFin')?.checked !== false
    const showPagos = document.getElementById('calFilterPagos')?.checked !== false
    const showCumples = document.getElementById('calFilterCumples')?.checked !== false
    const showHitos = document.getElementById('calFilterHitos')?.checked !== false
    const searchQuery = (store.calendarSearchQuery || '').toLowerCase().trim()

    const allLeads = [...(leads || []), ...(historico || [])]

    allLeads.forEach(l => {
        try {
            // Only show confirmed trips: deposit paid, not canceled
            if (l.stage === 'cancelado' || l.stage === 'no_compro') return
            if ((l.abonado || 0) <= 0) return

            const titular = l.titular || l.clientName || 'Cliente'
            // Usar nombre y apellido (primeras 2 palabras) en lugar de solo el nombre
            const nameParts = titular.split(' ')
            const displayName = nameParts.length > 1 ? `${nameParts[0]} ${nameParts[1]}` : nameParts[0]

            // Filtro de búsqueda - si hay query, verificar que el lead coincida
            if (searchQuery) {
                const matchSearch =
                    (titular.toLowerCase().includes(searchQuery)) ||
                    ((l.destination || '').toLowerCase().includes(searchQuery)) ||
                    ((l.phone || '').includes(searchQuery)) ||
                    ((l.contacto || '').toLowerCase().includes(searchQuery))
                if (!matchSearch) return // Skip este lead si no coincide con la búsqueda
            }

            // Inicio de viaje
            if (showViajeInicio && l.travelDate) {
                events.push({
                    date: l.travelDate,
                    type: 'viaje',
                    icon: '✈️',
                    label: displayName,
                    title: `✈️ Viaje: ${titular}\n${l.destination || ''}`,
                    leadId: l.id
                })
            }

            // Fin de viaje / Regreso
            if (showViajeFin && l.travelEnd) {
                events.push({
                    date: l.travelEnd,
                    type: 'viaje-fin',
                    icon: '🏠',
                    label: displayName,
                    title: `🏠 Regreso: ${titular}`,
                    leadId: l.id
                })
            }

            // Pagos
            if (showPagos) {
                if (l.fechaAbono && (l.abonado || 0) < (l.abono || 0)) {
                    events.push({
                        date: l.fechaAbono,
                        type: 'pago',
                        icon: '💰',
                        label: `Abono ${displayName}`,
                        title: `💰 Límite abono: ${titular}\n$${l.abono || 0} USD`,
                        leadId: l.id
                    })
                }
                if (l.fechaPagoFinal && (l.abonado || 0) < (l.totalVenta || 0)) {
                    events.push({
                        date: l.fechaPagoFinal,
                        type: 'pago',
                        icon: '💰',
                        label: `Pago ${displayName}`,
                        title: `💰 Pago final: ${titular}\n$${(l.totalVenta || 0) - (l.abonado || 0)} USD pendiente`,
                        leadId: l.id
                    })
                }
            }

            // Cumpleaños
            if (showCumples && l.grupoViajeros) {
                l.grupoViajeros.forEach(v => {
                    try {
                        if (v && v.fechaNacimiento && typeof v.fechaNacimiento === 'string') {
                            const bParts = v.fechaNacimiento.split('T')[0].split('-').map(Number)
                            if (bParts.length >= 3 && !isNaN(bParts[0])) {
                                const currentYear = calCurrentDate.getFullYear()
                                // Nombre y apellido del viajero
                                const vName = v.nombre || 'Viajero'
                                const vParts = vName.split(' ')
                                const vDisplay = vParts.length > 1 ? `${vParts[0]} ${vParts[1]}` : vParts[0]

                                [currentYear, currentYear + 1].forEach(year => {
                                    const edad = year - bParts[0]
                                    const dateStr = `${year}-${String(bParts[1]).padStart(2,'0')}-${String(bParts[2]).padStart(2,'0')}`
                                    events.push({
                                        date: dateStr,
                                        type: 'cumple',
                                        icon: '🎂',
                                        label: `${vDisplay} (${edad})`,
                                        title: `🎂 Cumpleaños: ${vName}\nCumple ${edad} años\nViaje: ${titular}`,
                                        leadId: l.id
                                    })
                                })
                            }
                        }
                    } catch (e) { /* ignore */ }
                })
            }

            // Hitos (basados en fecha de viaje) - USANDO CONFIGURACIÓN
            if (showHitos && l.travelDate && typeof l.travelDate === 'string') {
                const tParts = l.travelDate.split('T')[0].split('-').map(Number)
                if (tParts.length >= 3 && !isNaN(tParts[0])) {
                    const travelDate = new Date(tParts[0], tParts[1] - 1, tParts[2])

                    const tipo = l.type || ''
                    const platform = (l.platform || '').toLowerCase()
                    const dest = (l.destination || '').toLowerCase()
                    const allText = tipo + ' ' + platform + ' ' + dest

                    // Determinar operadores aplicables (additive — a lead can have multiple trip types)
                    const operadoresAplicables = []
                    const isCruise = tipo === 'crucero' || allText.includes('cruise') || allText.includes('crucero') || allText.includes('msc') || allText.includes('royal caribbean')
                    const isDisney = tipo === 'disney' || allText.includes('disney')
                    const isUniversal = tipo === 'universal' || allText.includes('universal')
                    const isHotel = tipo === 'hotel' || (allText.includes('hotel') && !allText.includes('disney'))

                    if (isCruise && isDisney) {
                        operadoresAplicables.push('disney_cruise', 'crucero')
                    } else if (isCruise) {
                        operadoresAplicables.push('crucero')
                    }
                    if (isDisney && !isCruise) {
                        operadoresAplicables.push('disney')
                    }
                    if (isUniversal) {
                        operadoresAplicables.push('universal')
                    }
                    if (isHotel) {
                        operadoresAplicables.push('hotel')
                    }
                    if (operadoresAplicables.length === 0) {
                        operadoresAplicables.push('otro')
                    }

                    // Obtener hitos activos de la configuración
                    const hitosConfig = (settings && settings.hitos) || (defaultSettings && defaultSettings.hitos) || []
                    const hitosActivos = hitosConfig.filter(h => h && h.activo && operadoresAplicables.includes(h.operador))

                    hitosActivos.forEach(hito => {
                        try {
                            const hitoDate = new Date(travelDate)
                            hitoDate.setDate(hitoDate.getDate() - hito.dias)

                            const dateStr = `${hitoDate.getFullYear()}-${String(hitoDate.getMonth()+1).padStart(2,'0')}-${String(hitoDate.getDate()).padStart(2,'0')}`

                            let eventType = 'hito'
                            if (hito.icon === '🍽️') eventType = 'hito-dining'
                            else if (hito.icon === '⚡') eventType = 'hito-ll'
                            else if (hito.icon === '🚢') eventType = 'hito-checkin'

                            events.push({
                                date: dateStr,
                                type: eventType,
                                icon: hito.icon,
                                label: `${(hito.nombre || '').split(' ')[0]} ${displayName}`,
                                title: `${hito.icon} ${hito.nombre}\n${titular}\nViaje: ${window.fmtDate(l.travelDate)}`,
                                leadId: l.id
                            })
                        } catch (e) { /* ignore */ }
                    })
                }
            }
        } catch (err) {
            console.error('Error processing lead for calendar:', l.id, err)
        }
    })

    return events
}

function renderCalendario() {
    try {
        const year = calCurrentDate.getFullYear()
        const month = calCurrentDate.getMonth()

        // Update title
        const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
        const titleEl = document.getElementById('calMonthTitle')
        if (titleEl) titleEl.textContent = `${monthNames[month]} ${year}`

        // Get first day of month and total days
        const firstDay = new Date(year, month, 1)
        const lastDay = new Date(year, month + 1, 0)
        const startDayOfWeek = firstDay.getDay() // 0 = Sunday
        const totalDays = lastDay.getDate()

        // Get events (con try-catch para evitar que errores rompan el calendario)
        let events = []
        try {
            events = getCalendarEvents()
        } catch (err) {
            console.error('Error getting calendar events:', err)
        }

        // Build calendar HTML
        let html = ''

        // Day headers
        const dayNames = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']
        dayNames.forEach(d => {
            html += `<div class="cal-day-header">${d}</div>`
        })

        // Previous month days
        const prevMonthLastDay = new Date(year, month, 0).getDate()
        for (let i = startDayOfWeek - 1; i >= 0; i--) {
            const day = prevMonthLastDay - i
            html += `<div class="cal-day other-month"><span class="cal-day-num">${day}</span></div>`
        }

        // Current month days
        const today = new Date()
        for (let day = 1; day <= totalDays; day++) {
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
            const isToday = today.getFullYear() === year && today.getMonth() === month && today.getDate() === day

            // Get events for this day
            const dayEvents = events.filter(e => {
                if (!e || !e.date) return false
                try {
                    const datePart = String(e.date).split('T')[0]
                    const eParts = datePart.split('-').map(Number)
                    if (eParts.length < 3 || isNaN(eParts[0])) return false
                    return eParts[0] === year && (eParts[1] - 1) === month && eParts[2] === day
                } catch (err) {
                    return false
                }
            })

            html += `<div class="cal-day${isToday ? ' today' : ''}" onclick="showDayEvents('${dateStr}')">`
            html += `<span class="cal-day-num">${day}</span>`

            // Show max 3 events, then "+X more"
            const maxShow = 3
            dayEvents.slice(0, maxShow).forEach(e => {
                const safeTitle = (e.title || '').replace(/"/g, '&quot;').replace(/\n/g, ' ')
                html += `<div class="cal-event ${e.type || ''}" onclick="event.stopPropagation();showDayEvents('${dateStr}')" title="${safeTitle}">${e.icon || ''} ${e.label || ''}</div>`
            })

            if (dayEvents.length > maxShow) {
                html += `<div class="cal-more">+${dayEvents.length - maxShow} más</div>`
            }

            html += '</div>'
        }

        // Next month days to fill grid
        const totalCells = startDayOfWeek + totalDays
        const remainingCells = totalCells % 7 === 0 ? 0 : 7 - (totalCells % 7)
        for (let i = 1; i <= remainingCells; i++) {
            html += `<div class="cal-day other-month"><span class="cal-day-num">${i}</span></div>`
        }

        const gridEl = document.getElementById('calendarioGrid')
        if (gridEl) gridEl.innerHTML = html

        // Update badge with events this month
        let monthEventCount = 0
        try {
            monthEventCount = events.filter(e => {
                if (!e || !e.date) return false
                const datePart = String(e.date).split('T')[0]
                const eParts = datePart.split('-').map(Number)
                return eParts.length >= 3 && eParts[0] === year && (eParts[1] - 1) === month
            }).length
        } catch (err) {}

        const badgeEl = document.getElementById('badgeCalendario')
        if (badgeEl) badgeEl.textContent = monthEventCount
    } catch (err) {
        console.error('Error in renderCalendario:', err)
    }
}

// ========== CALENDAR PICKER (Mes/Año) ==========
let calPickerSelectedYear = new Date().getFullYear()

function openCalPicker() {
    calPickerSelectedYear = calCurrentDate.getFullYear()
    renderCalPickerMonths()
    window.openModal('calPickerModal')
}

function calPickerYearNav(delta) {
    calPickerSelectedYear += delta
    renderCalPickerMonths()
}

function renderCalPickerMonths() {
    document.getElementById('calPickerYearDisplay').textContent = calPickerSelectedYear

    const monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
    const currentMonth = calCurrentDate.getMonth()
    const currentYear = calCurrentDate.getFullYear()
    const today = new Date()

    let html = ''
    monthNames.forEach((name, idx) => {
        const isSelected = calPickerSelectedYear === currentYear && idx === currentMonth
        const isCurrent = calPickerSelectedYear === today.getFullYear() && idx === today.getMonth()

        html += `<div class="cal-picker-month${isSelected ? ' selected' : ''}${isCurrent && !isSelected ? ' current' : ''}"
                     onclick="selectCalMonth(${idx})">
            ${name}
        </div>`
    })

    document.getElementById('calPickerMonths').innerHTML = html
}

function selectCalMonth(month) {
    calCurrentDate = new Date(calPickerSelectedYear, month, 1)
    window.closeModal('calPickerModal')
    renderCalendario()
}

// ========== CALENDAR DAY DETAIL ==========
let calDayEventsCache = []

function showDayEvents(dateStr) {
    const events = getCalendarEvents()

    // Parsear fecha sin problemas de timezone
    const [year, month, day] = dateStr.split('-').map(Number)
    const targetDate = new Date(year, month - 1, day)

    const dayEvents = events.filter(e => {
        if (!e.date || typeof e.date !== 'string') return false
        // Parsear fecha del evento sin timezone
        const eParts = e.date.split('T')[0].split('-').map(Number)
        if (eParts.length < 3 || isNaN(eParts[0])) return false
        const eventDate = new Date(eParts[0], eParts[1] - 1, eParts[2])
        return eventDate.toDateString() === targetDate.toDateString()
    })

    calDayEventsCache = dayEvents

    // Format date for title
    const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
    document.getElementById('calDayTitle').textContent = `📅 ${dayNames[targetDate.getDay()]} ${targetDate.getDate()} de ${monthNames[targetDate.getMonth()]}`

    if (dayEvents.length === 0) {
        document.getElementById('calDayEvents').innerHTML = `
            <div style="text-align:center;padding:30px;color:var(--text-3);">
                <div style="font-size:40px;margin-bottom:12px;">📭</div>
                <div>No hay eventos para este día</div>
            </div>`
    } else {
        let html = ''
        dayEvents.forEach((e, idx) => {
            // Usar tipo exacto para viaje/viaje-fin
            let typeClass = e.type || 'hito'
            if (typeClass !== 'viaje' && typeClass !== 'viaje-fin') {
                if (typeClass.includes('pago')) typeClass = 'pago'
                else if (typeClass.includes('cumple')) typeClass = 'cumple'
                else typeClass = 'hito'
            }

            const details = (e.title || '').split('\n').slice(1).join('\n')

            html += `<div class="cal-day-event-card ${typeClass}">
                <div class="cal-day-event-header">
                    <span class="cal-day-event-icon">${e.icon}</span>
                    <span class="cal-day-event-title">${(e.title || '').split('\n')[0].replace(/^[^\s]+\s/, '')}</span>
                </div>
                ${details ? `<div class="cal-day-event-desc">${details}</div>` : ''}
                <div class="cal-day-event-actions" style="flex-wrap:wrap;">
                    <button class="btn btn-sm btn-primary" onclick="viewLeadFromEvent(${idx})">
                        👤 Ver Lead
                    </button>
                    <button class="btn btn-sm btn-secondary" onclick="addToGoogleCal(${idx})">
                        📅 G.Calendar
                    </button>
                    <button class="btn btn-sm btn-whatsapp" onclick="sendWhatsApp(${idx})">
                        📱 WhatsApp
                    </button>
                    <button class="btn btn-sm btn-ghost" onclick="sendEmail(${idx})">
                        📧 Email
                    </button>
                </div>
            </div>`
        })
        document.getElementById('calDayEvents').innerHTML = html
    }

    window.openModal('calDayModal')
}

function viewLeadFromEvent(eventIdx) {
    const event = calDayEventsCache[eventIdx]
    if (!event || !event.leadId) {
        window.toast('No se encontró el lead', 'error')
        return
    }
    window.closeModal('calDayModal')
    window.openPanel(event.leadId)
}

function sendWhatsApp(eventIdx) {
    const { leads, historico } = store
    const event = calDayEventsCache[eventIdx]
    if (!event) return

    // Buscar el lead para obtener datos
    const lead = leads.find(l => l.id === event.leadId) || historico.find(h => h.id === event.leadId)
    if (!lead) {
        window.toast('No se encontró el lead', 'error')
        return
    }

    const phone = lead.phone || lead.tel
    if (!phone) {
        window.toast('El cliente no tiene teléfono registrado', 'error')
        return
    }

    // Determinar categoría y generar mensaje
    const categoria = getPlantillaCategoriaFromEvent(event, lead)
    const datos = buildMensajeDatos(event, lead)
    const mensaje = window.generarMensaje(categoria, datos)

    const url = window.generarWhatsAppLink(phone, mensaje)
    window.open(url, '_blank')
}

function sendEmail(eventIdx) {
    const { leads, historico, clients } = store
    const event = calDayEventsCache[eventIdx]
    if (!event) return

    // Buscar el lead para obtener datos
    const lead = leads.find(l => l.id === event.leadId) || historico.find(h => h.id === event.leadId)
    if (!lead) {
        window.toast('No se encontró el lead', 'error')
        return
    }

    const email = lead.email || (clients[lead.clientKey]?.email)
    if (!email) {
        window.toast('El cliente no tiene email registrado', 'error')
        return
    }

    // Determinar categoría y generar mensaje
    const categoria = getPlantillaCategoriaFromEvent(event, lead)
    const datos = buildMensajeDatos(event, lead)
    const mensaje = window.generarMensaje(categoria, datos)

    // Generar asunto basado en el evento
    const asunto = `${event.icon} ${(event.title || '').split('\n')[0].replace(/^[^\s]+\s/, '')} - Mind2Magic`

    const url = window.generarEmailLink(email, asunto, mensaje)
    window.location.href = url
}

function getPlantillaCategoriaFromEvent(event, lead) {
    const type = event.type || ''
    const operador = lead.type || ''

    if (type.includes('viaje') && !type.includes('fin')) return 'viaje_inicio'
    if (type.includes('viaje-fin')) return 'viaje_fin'
    if (type.includes('pago')) {
        return event.title.toLowerCase().includes('abono') ? 'pago_abono' : 'pago_final'
    }
    if (type.includes('cumple')) return 'cumpleanos'
    if (type.includes('hito')) {
        if (operador === 'disney') return 'hito_disney'
        if (operador === 'crucero') return 'hito_crucero'
        if (operador === 'universal') return 'hito_universal'
        return 'hito_general'
    }
    return 'hito_general'
}

function buildMensajeDatos(event, lead) {
    const hoy = new Date()
    const eventDate = new Date(event.date)
    const diasPara = Math.ceil((eventDate - hoy) / (1000 * 60 * 60 * 24))

    // Obtener nombre del titular o del viajero si es cumpleaños
    let nombre = lead.titular || lead.clientName || 'Cliente'
    if (event.type === 'cumple' && event.label) {
        // Extraer nombre del label del cumpleaños
        const match = event.label.match(/^([^\(]+)/)
        if (match) nombre = match[1].trim()
    }

    // Calcular monto pendiente
    let monto = 0
    if (event.type === 'pago') {
        if (event.title.toLowerCase().includes('abono')) {
            monto = (lead.abono || 0) - (lead.abonado || 0)
        } else {
            monto = (lead.totalVenta || 0) - (lead.abonado || 0)
        }
    }

    // Extraer hito del título
    const hitoMatch = event.title.match(/^[^\n]+/)
    const hito = hitoMatch ? hitoMatch[0].replace(/^[^\s]+\s/, '').toLowerCase() : ''

    return {
        nombre: nombre.split(' ')[0], // Solo primer nombre
        titular: nombre,
        destino: lead.destination || 'tu destino',
        fecha_viaje: lead.travelDate ? window.fmtDate(lead.travelDate) : 'próximamente',
        dias_para: diasPara > 0 ? diasPara : 'hoy',
        monto: monto > 0 ? monto.toFixed(0) : '0',
        hito: hito
    }
}

function addToGoogleCal(eventIdx) {
    const event = calDayEventsCache[eventIdx]
    if (!event) return

    const url = generateGoogleCalLink(event)
    window.open(url, '_blank')
}

function generateGoogleCalLink(event) {
    const startDate = new Date(event.date)
    // Set to 9am local time for better calendar display
    startDate.setHours(9, 0, 0, 0)
    const endDate = new Date(startDate)
    endDate.setHours(10, 0, 0, 0)

    const formatDate = (d) => {
        const pad = n => String(n).padStart(2, '0')
        return `${d.getFullYear()}${pad(d.getMonth()+1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`
    }

    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: (event.title || '').split('\n')[0],
        dates: `${formatDate(startDate)}/${formatDate(endDate)}`,
        details: (event.title || '').replace(/\n/g, '%0A')
    })

    return `https://calendar.google.com/calendar/render?${params.toString()}`
}

// Toast, Modal — extracted to src/ui.js (Step 7)

function setupUploadZone() {
    const z = document.getElementById('uploadZone')
    z.ondragover = e => { e.preventDefault(); z.classList.add('over') }
    z.ondragleave = () => z.classList.remove('over')
    z.ondrop = e => { e.preventDefault(); z.classList.remove('over')
        const f = e.dataTransfer.files[0]
        if (f && (f.name.endsWith('.xlsx') || f.name.endsWith('.xls'))) {
            const r = new FileReader()
            r.onload = evt => window.processWorkbook(XLSX.read(evt.target.result, { type: 'binary', cellDates: true }))
            r.readAsBinaryString(f)
        }
    }

    // Typeform upload zone
    const tfz = document.getElementById('tfUploadZone')
    if (tfz) {
        tfz.ondragover = e => { e.preventDefault(); tfz.classList.add('over') }
        tfz.ondragleave = () => tfz.classList.remove('over')
        tfz.ondrop = e => { e.preventDefault(); tfz.classList.remove('over')
            const f = e.dataTransfer.files[0]
            if (f && (f.name.endsWith('.xlsx') || f.name.endsWith('.xls'))) {
                // Simulate file input change
                const dt = new DataTransfer()
                dt.items.add(f)
                document.getElementById('tfFileInput').files = dt.files
                window.handleTypeformFile({ target: { files: [f], value: f.name } })
            }
        }
    }
}

// UI Font Scale + Zoom — extracted to src/ui.js (Step 7)


function exportToExcel() {
    const { leads, historico, settings } = store
    const wb = XLSX.utils.book_new()

    // VENTAS by year (dynamic)
    const ventasStages = ['pago_completo', 'reserva_abono', 'prereserva', 'documentacion', 'en_destino', 'finalizado']
    const yearSet = new Set()
    leads.forEach(l => {
        if (l.travelDate && ventasStages.includes(l.stage)) {
            const y = new Date(l.travelDate).getFullYear()
            if (y >= 2020 && y <= 2100) yearSet.add(y)
        }
    });
    [...yearSet].sort().forEach(year => {
        const ventasYear = leads.filter(l => {
            const d = l.travelDate ? new Date(l.travelDate) : null
            return d && d.getFullYear() === year && ventasStages.includes(l.stage)
        }).map(l => ({
            'Client Name': l.contacto && l.contacto !== l.titular ? `${l.titular} (${l.contacto})` : l.titular,
            'Celular': l.phone || '',
            'Email': l.email || '',
            'Travel Date': l.travelDate || '',
            'Destination': l.destination || '',
            'Detalle del Plan': TYPE_LABELS[l.type] || '',
            'Total Venta': l.totalVenta || 0,
            'Abono Req.': l.abono || 0,
            'Abonado': l.abonado || 0,
            'Fecha Abono': l.fechaAbono || '',
            'Saldo Pendiente': Math.max(0, (l.totalVenta || 0) - (l.abonado || 0)),
            'Fecha Pago Final': l.fechaPagoFinal || '',
            'Total Commission': l.commission || 0,
            '70%': l.commission70 || 0,
            'Responsable': l.responsable || '',
            'Etapa': STAGES.find(s => s.id === l.stage)?.name || l.stage
        }))
        if (ventasYear.length) {
            const ws = XLSX.utils.json_to_sheet(ventasYear)
            XLSX.utils.book_append_sheet(wb, ws, `VENTAS ${year}`)
        }
    })

    // PROSPECTOS 2025 - nuevos leads sin pago
    const prospectos = leads.filter(l => ['nuevo', 'formulario', 'asesoria_solicitada', 'asesoria_agendada', 'asesoria_realizada', 'cotizacion'].includes(l.stage)).map(l => ({
        'Client Name': l.contacto && l.contacto !== l.titular ? `${l.titular} (${l.contacto})` : l.titular,
        'Leads': 'Activo',
        'Contacto': l.phone || '',
        'Email': l.email || '',
        'Travel Date': l.travelDate || '',
        'Destino Preliminar': l.destination || '',
        'Responsable': l.responsable || '',
        'Etapa': STAGES.find(s => s.id === l.stage)?.name || l.stage
    }))
    if (prospectos.length) {
        const ws3 = XLSX.utils.json_to_sheet(prospectos)
        XLSX.utils.book_append_sheet(wb, ws3, `PROSPECTOS ${new Date().getFullYear()}`)
    }

    // HISTORICO
    if (historico.length) {
        const histData = historico.map(h => ({
            'Client Name': h.titular || '',
            'Travel Date': h.travelDate || '',
            'Destination': h.destination || '',
            'Total Venta': h.totalVenta || 0,
            'Total Commission': h.commission || 0,
            '70%': h.commission70 || 0
        }))
        const ws4 = XLSX.utils.json_to_sheet(histData)
        XLSX.utils.book_append_sheet(wb, ws4, 'HISTORICO')
    }

    // Descargar
    const date = new Date().toISOString().split('T')[0]
    XLSX.writeFile(wb, `Mind2Magic_CRM_${date}.xlsx`)
    window.toast('Excel exportado correctamente', 'success')
}

// ========== ENTER PARA NAVEGAR ENTRE CAMPOS ==========
document.addEventListener('keydown', e => {
    // Enter in modal inputs → save (click the primary button)
    if (e.key !== 'Enter') return
    const target = e.target
    if (target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') return
    const modal = target.closest('.modal')
    if (!modal) return
    const isFormField = target.matches('input:not([type="submit"]):not([type="button"])')
    if (!isFormField) return

    e.preventDefault()
    const saveBtn = modal.querySelector('.modal-foot .btn-primary, .modal-foot .btn-success')
    if (saveBtn) saveBtn.click()
})

document.addEventListener('keydown', e => {
    // Escape para cerrar modales
    if (e.key === 'Escape') {
        window.closeModal('newLeadModal'); window.closeModal('editLeadModal'); window.closeModal('newTeamModal'); window.closeModal('editTeamModal'); window.closeModal('settingsModal'); window.closeModal('newTareaModal'); window.closePanel(); window.cancelSelection()
    }
    // Ctrl+Z para deshacer
    if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
        e.preventDefault()
        window.undo()
    }
    // Ctrl+Y o Ctrl+Shift+Z para rehacer
    if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) {
        e.preventDefault()
        window.redo()
    }
})

// ========== SISTEMA DE TAREAS ==========
function loadTareas() {
    const { tareas } = store
    const saved = localStorage.getItem('m2m_tareas')
    if (saved) {
        try {
            store.tareas = JSON.parse(saved)
        } catch (e) {
            store.tareas = []
        }
    }
    updateTareasBadge()
}

function saveTareas(modifiedTarea) {
    const { tareas } = store
    localStorage.setItem('m2m_tareas', JSON.stringify(tareas))
    // Sync the specific modified tarea to Supabase
    if (modifiedTarea) {
        window.syncTareaToSupabase(modifiedTarea)
    }
    updateTareasBadge()
}

function updateTareasBadge() {
    const { tareas } = store
    const pendientes = tareas.filter(t => t.estado === 'pendiente').length
    const badge = document.getElementById('badgeTareas')
    if (badge) {
        badge.textContent = pendientes
        badge.style.display = pendientes > 0 ? 'flex' : 'none'
    }
}

function renderTareas() {
    const { leads, historico, team, tareas } = store
    const filterResp = document.getElementById('filterTareaResponsable')?.value || ''
    const filterEstado = document.getElementById('filterTareaEstado')?.value || ''

    // Poblar filtro de responsables
    const respSelect = document.getElementById('filterTareaResponsable')
    if (respSelect && respSelect.options.length <= 1) {
        respSelect.innerHTML = '<option value="">Todos</option>' +
            team.map(t => `<option value="${t.nombre}">${t.nombre}</option>`).join('')
    }

    // Filtrar tareas
    let filtered = [...tareas]
    if (filterResp) filtered = filtered.filter(t => t.responsable === filterResp)
    if (filterEstado) filtered = filtered.filter(t => t.estado === filterEstado)

    // Ordenar: pendientes primero, luego por fecha
    filtered.sort((a, b) => {
        if (a.estado !== b.estado) return a.estado === 'pendiente' ? -1 : 1
        if (!a.fechaLimite) return 1
        if (!b.fechaLimite) return -1
        return new Date(a.fechaLimite) - new Date(b.fechaLimite)
    })

    // Calcular estadísticas
    const hoy = new Date()
    hoy.setHours(0,0,0,0)
    const stats = {
        pendientes: tareas.filter(t => t.estado === 'pendiente').length,
        hoy: tareas.filter(t => {
            if (t.estado !== 'pendiente' || !t.fechaLimite) return false
            const fecha = new Date(t.fechaLimite)
            fecha.setHours(0,0,0,0)
            return fecha.getTime() === hoy.getTime()
        }).length,
        vencidas: tareas.filter(t => {
            if (t.estado !== 'pendiente' || !t.fechaLimite) return false
            const fecha = new Date(t.fechaLimite)
            fecha.setHours(0,0,0,0)
            return fecha < hoy
        }).length,
        completadas: tareas.filter(t => t.estado === 'completada').length
    }

    document.getElementById('tareasPendientes').textContent = stats.pendientes
    document.getElementById('tareasHoy').textContent = stats.hoy
    document.getElementById('tareasVencidas').textContent = stats.vencidas
    document.getElementById('tareasCompletadas').textContent = stats.completadas

    // Renderizar lista
    const container = document.getElementById('tareasList')
    if (!filtered.length) {
        container.innerHTML = `<div style="text-align:center;padding:40px;color:var(--text-3);">
            <div style="font-size:40px;margin-bottom:12px;">✅</div>
            <div>No hay tareas ${filterEstado === 'pendiente' ? 'pendientes' : filterEstado === 'completada' ? 'completadas' : ''}</div>
            <button class="btn btn-primary btn-sm" style="margin-top:16px;" onclick="openNewTareaModal()">+ Crear primera tarea</button>
        </div>`
        return
    }

    container.innerHTML = filtered.map(t => {
        const isCompletada = t.estado === 'completada'
        let statusClass = ''
        let fechaLabel = ''

        if (t.fechaLimite && !isCompletada) {
            const fecha = new Date(t.fechaLimite)
            fecha.setHours(0,0,0,0)
            const diff = Math.ceil((fecha - hoy) / (1000*60*60*24))

            if (diff < 0) {
                statusClass = 'vencida'
                fechaLabel = `<span class="fecha-vencida">⚠️ Vencida (${Math.abs(diff)}d)</span>`
            } else if (diff === 0) {
                statusClass = 'hoy'
                fechaLabel = `<span class="fecha-hoy">📌 Hoy</span>`
            } else if (diff === 1) {
                fechaLabel = `<span class="fecha-pronto">Mañana</span>`
            } else if (diff <= 7) {
                fechaLabel = `<span class="fecha-pronto">En ${diff} días</span>`
            } else {
                fechaLabel = window.fmtDate(t.fechaLimite)
            }
        } else if (t.fechaLimite) {
            fechaLabel = window.fmtDate(t.fechaLimite)
        }

        if (t.prioridad === 'alta' && !isCompletada) statusClass = 'alta'
        if (t.prioridad === 'baja' && !isCompletada && !statusClass) statusClass = 'baja'
        if (isCompletada) statusClass = 'completada'

        const lead = t.leadId ? (leads.find(l => l.id === t.leadId) || historico.find(l => l.id === t.leadId)) : null

        return `<div class="tarea-card ${statusClass}">
            <div class="tarea-checkbox ${isCompletada ? 'checked' : ''}" onclick="toggleTarea('${t.id}')">
                ${isCompletada ? '✓' : ''}
            </div>
            <div class="tarea-content">
                <div class="tarea-titulo">${t.prioridad === 'alta' ? '🔴 ' : t.prioridad === 'baja' ? '🟢 ' : ''}${window.escHtml(t.titulo)}</div>
                ${t.descripcion ? `<div class="tarea-desc">${t.descripcion}</div>` : ''}
                <div class="tarea-meta">
                    <span>👤 ${t.responsable}</span>
                    ${fechaLabel ? `<span>📅 ${fechaLabel}</span>` : ''}
                    ${lead ? `<span class="tarea-lead-link" onclick="openLead('${t.leadId}')">🔗 ${lead.titular?.split(' ')[0] || 'Lead'}</span>` : ''}
                    <span style="opacity:0.6;">Creada por ${t.creadoPor}</span>
                </div>
            </div>
            <div class="tarea-actions">
                <button class="btn btn-sm btn-ghost" onclick="editTarea('${t.id}')" title="Editar">✎</button>
                <button class="btn btn-sm btn-ghost" onclick="deleteTarea('${t.id}')" title="Eliminar" style="color:var(--red);">🗑</button>
            </div>
        </div>`
    }).join('')
}

function openNewTareaModal(leadId = null) {
    const { leads, historico, team } = store
    document.getElementById('tareaModalTitle').textContent = '✅ Nueva Tarea'
    document.getElementById('tareaEditId').value = ''
    document.getElementById('tareaTitulo').value = ''
    document.getElementById('tareaDescripcion').value = ''
    document.getElementById('tareaFechaLimite').value = ''
    document.getElementById('tareaPrioridad').value = 'normal'

    // Poblar select de responsables
    const respSelect = document.getElementById('tareaResponsable')
    respSelect.innerHTML = team.map(t => `<option value="${t.nombre}">${t.nombre}</option>`).join('')

    // Poblar select de leads
    const leadSelect = document.getElementById('tareaLeadId')
    const allLeads = [...leads, ...historico].sort((a,b) => (a.titular || '').localeCompare(b.titular || ''))
    leadSelect.innerHTML = '<option value="">-- Sin vincular --</option>' +
        allLeads.map(l => `<option value="${l.id}">${l.titular || 'Sin nombre'} - ${l.destination || 'Sin destino'}</option>`).join('')

    if (leadId) {
        leadSelect.value = leadId
    }

    window.openModal('newTareaModal')
    document.getElementById('tareaTitulo').focus()
}

function editTarea(id) {
    const { leads, historico, team, tareas } = store
    const tarea = tareas.find(t => t.id === id)
    if (!tarea) return

    document.getElementById('tareaModalTitle').textContent = '✎ Editar Tarea'
    document.getElementById('tareaEditId').value = id
    document.getElementById('tareaTitulo').value = tarea.titulo
    document.getElementById('tareaDescripcion').value = tarea.descripcion || ''
    document.getElementById('tareaFechaLimite').value = tarea.fechaLimite || ''
    document.getElementById('tareaPrioridad').value = tarea.prioridad || 'normal'

    // Poblar y seleccionar responsable
    const respSelect = document.getElementById('tareaResponsable')
    respSelect.innerHTML = team.map(t => `<option value="${t.nombre}" ${t.nombre === tarea.responsable ? 'selected' : ''}>${t.nombre}</option>`).join('')

    // Poblar y seleccionar lead
    const leadSelect = document.getElementById('tareaLeadId')
    const allLeads = [...leads, ...historico].sort((a,b) => (a.titular || '').localeCompare(b.titular || ''))
    leadSelect.innerHTML = '<option value="">-- Sin vincular --</option>' +
        allLeads.map(l => `<option value="${l.id}" ${l.id === tarea.leadId ? 'selected' : ''}>${l.titular || 'Sin nombre'} - ${l.destination || 'Sin destino'}</option>`).join('')

    window.openModal('newTareaModal')
}

function saveTarea() {
    const { team, tareas } = store
    const titulo = document.getElementById('tareaTitulo').value.trim()
    if (!titulo) {
        window.toast('El título es requerido', 'error')
        return
    }

    const editId = document.getElementById('tareaEditId').value
    const tareaData = {
        id: editId || 'tarea_' + Date.now(),
        titulo: titulo,
        descripcion: document.getElementById('tareaDescripcion').value.trim(),
        responsable: document.getElementById('tareaResponsable').value,
        fechaLimite: document.getElementById('tareaFechaLimite').value || null,
        leadId: document.getElementById('tareaLeadId').value || null,
        prioridad: document.getElementById('tareaPrioridad').value,
        estado: 'pendiente',
        creadoPor: team[0]?.nombre || 'Sara',
        fechaCreacion: new Date().toISOString()
    }

    if (editId) {
        const idx = tareas.findIndex(t => t.id === editId)
        if (idx >= 0) {
            tareaData.estado = tareas[idx].estado
            tareaData.fechaCreacion = tareas[idx].fechaCreacion
            tareaData.creadoPor = tareas[idx].creadoPor
            tareas[idx] = tareaData
            window.toast('Tarea actualizada', 'success')
        }
    } else {
        tareas.push(tareaData)
        window.toast('Tarea creada', 'success')
    }

    saveTareas(tareaData)
    window.closeModal('newTareaModal')
    renderTareas()
}

function toggleTarea(id) {
    const { tareas } = store
    const tarea = tareas.find(t => t.id === id)
    if (!tarea) return

    tarea.estado = tarea.estado === 'completada' ? 'pendiente' : 'completada'
    if (tarea.estado === 'completada') {
        tarea.fechaCompletada = new Date().toISOString()
    }

    saveTareas(tarea)
    renderTareas()
    window.toast(tarea.estado === 'completada' ? '✅ Tarea completada' : 'Tarea reabierta', 'success')
}

function deleteTarea(id) {
    if (!confirm('¿Eliminar esta tarea?')) return

    const tarea = store.tareas.find(t => t.id === id)
    store.tareas = store.tareas.filter(t => t.id !== id)
    // Delete from Supabase
    if (tarea?._supabaseId || tarea?.id) {
        supabaseDB.deleteTarea(tarea._supabaseId || tarea.id).catch(err => console.error('deleteTarea sync error:', err))
    }
    saveTareas(null) // localStorage only, no sync needed (deleted above)
    renderTareas()
    window.toast('Tarea eliminada', 'success')
}

// ========== SISTEMA DE COMENTARIOS ==========

function _renderComentariosList(lead) {
    const comentariosList = document.getElementById('comentariosList')
    if (!comentariosList) return
    const comentarios = lead.comentarios || []
    comentariosList.innerHTML = comentarios.length ? comentarios.map(c => `
        <div class="comentario-item">
            <div class="comentario-header">
                <span class="comentario-autor">${window.escHtml(c.autor)}</span>
                <span class="comentario-fecha">${window.fmtDateTime(c.fecha)}</span>
            </div>
            <div class="comentario-texto">${window.escHtml(c.texto)}</div>
        </div>
    `).join('') : '<div style="text-align:center;padding:12px;color:var(--text-3);font-size:12px;">Sin comentarios aún</div>'
    // Update count in header
    const header = document.querySelector('.comentarios-header h4')
    if (header) header.textContent = `💬 Comentarios (${comentarios.length})`
}

async function loadComentariosFromSupabase(lead) {
    const supaId = lead._supabaseId || lead.id
    if (!supaId) return
    const rows = await supabaseDB.fetchComentarios(supaId)
    if (!rows || !rows.length) return
    // Merge: replace in-memory with Supabase data (source of truth)
    lead.comentarios = rows.map(r => ({
        id: r.id,
        _supabaseId: r.id,
        texto: r.texto,
        autor: r.autor,
        fecha: r.created_at
    }))
    _renderComentariosList(lead)
}

function renderComentarios(leadId) {
    const { leads, historico } = store
    const lead = leads.find(l => l.id === leadId) || historico.find(l => l.id === leadId)
    if (!lead) return ''

    // Async-load from Supabase after DOM renders (replaces stale in-memory data)
    setTimeout(() => loadComentariosFromSupabase(lead), 50)

    const comentarios = lead.comentarios || []

    return `
        <div class="comentarios-section">
            <div class="comentarios-header" onclick="toggleComentarios()">
                <h4>💬 Comentarios (${comentarios.length})</h4>
                <span id="comentariosToggle">▼</span>
            </div>
            <div id="comentariosContent" style="display:block;">
                <div class="comentarios-list" id="comentariosList">
                    ${comentarios.length ? comentarios.map(c => `
                        <div class="comentario-item">
                            <div class="comentario-header">
                                <span class="comentario-autor">${window.escHtml(c.autor)}</span>
                                <span class="comentario-fecha">${window.fmtDateTime(c.fecha)}</span>
                            </div>
                            <div class="comentario-texto">${window.escHtml(c.texto)}</div>
                        </div>
                    `).join('') : '<div style="text-align:center;padding:12px;color:var(--text-3);font-size:12px;">Sin comentarios aún</div>'}
                </div>
                <div class="comentario-input-wrap">
                    <textarea id="nuevoComentario" class="form-input" rows="2" placeholder="Agregar comentario..."></textarea>
                    <button class="btn btn-primary btn-sm" onclick="agregarComentario('${leadId}')" style="align-self:flex-end;">Enviar</button>
                </div>
            </div>
        </div>
    `
}

function toggleComentarios() {
    const content = document.getElementById('comentariosContent')
    const toggle = document.getElementById('comentariosToggle')
    if (content.style.display === 'none') {
        content.style.display = 'block'
        toggle.textContent = '▼'
    } else {
        content.style.display = 'none'
        toggle.textContent = '▶'
    }
}

function agregarComentario(leadId) {
    const { leads, historico, team } = store
    const textarea = document.getElementById('nuevoComentario')
    const texto = textarea.value.trim()
    if (!texto) {
        window.toast('Escribe un comentario', 'error')
        return
    }

    let lead = leads.find(l => l.id === leadId)
    let isHistorico = false
    if (!lead) {
        lead = historico.find(l => l.id === leadId)
        isHistorico = true
    }
    if (!lead) return

    if (!lead.comentarios) lead.comentarios = []

    const autor = team[0]?.nombre || 'Sara'
    const comentario = {
        id: 'com_' + Date.now(),
        texto: texto,
        autor: autor,
        fecha: new Date().toISOString()
    }

    lead.comentarios.push(comentario)
    textarea.value = ''

    // Re-renderizar solo la sección de comentarios
    _renderComentariosList(lead)

    window.saveState('comentario agregado')
    window.toast('Comentario agregado', 'success')

    // Persist to Supabase
    const supaId = lead._supabaseId || lead.id
    if (supaId) {
        supabaseDB.addComentario(supaId, autor, texto).then(row => {
            if (row) comentario._supabaseId = row.id
        }).catch(err => console.error('addComentario sync error:', err))
    }
}


// Función para obtener tareas de un lead específico
function getTareasForLead(leadId) {
    const { tareas } = store
    return tareas.filter(t => t.leadId === leadId)
}

function renderTareasEnPanel(leadId) {
    const tareasLead = getTareasForLead(leadId)
    const pendientes = tareasLead.filter(t => t.estado === 'pendiente')

    return `
        <div class="comentarios-section" style="margin-top:12px;padding-top:12px;">
            <div class="comentarios-header" onclick="toggleTareasPanel()">
                <h4>✅ Tareas (${pendientes.length} pendiente${pendientes.length !== 1 ? 's' : ''})</h4>
                <span id="tareasToggle">▼</span>
            </div>
            <div id="tareasContent" style="display:block;">
                <div style="max-height:200px;overflow-y:auto;margin-bottom:10px;">
                    ${tareasLead.length ? tareasLead.map(t => `
                        <div style="display:flex;align-items:center;gap:8px;padding:8px;background:var(--bg-2);border-radius:8px;margin-bottom:6px;${t.estado === 'completada' ? 'opacity:0.6;' : ''}">
                            <div class="tarea-checkbox ${t.estado === 'completada' ? 'checked' : ''}" onclick="toggleTarea('${t.id}');openLead('${leadId}');" style="width:18px;height:18px;font-size:10px;">
                                ${t.estado === 'completada' ? '✓' : ''}
                            </div>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:12px;font-weight:500;color:var(--text-1);${t.estado === 'completada' ? 'text-decoration:line-through;color:var(--text-3);' : ''}">${window.escHtml(t.titulo)}</div>
                                <div style="font-size:10px;color:var(--text-2);">👤 ${t.responsable}${t.fechaLimite ? ' • 📅 ' + window.fmtDate(t.fechaLimite) : ''}</div>
                            </div>
                        </div>
                    `).join('') : '<div style="text-align:center;padding:12px;color:var(--text-2);font-size:12px;">Sin tareas</div>'}
                </div>
                <button class="btn btn-sm btn-secondary btn-block" onclick="openNewTareaModal('${leadId}')">+ Nueva tarea para este lead</button>
            </div>
        </div>
    `
}

function toggleTareasPanel() {
    const content = document.getElementById('tareasContent')
    const toggle = document.getElementById('tareasToggle')
    if (content.style.display === 'none') {
        content.style.display = 'block'
        toggle.textContent = '▼'
    } else {
        content.style.display = 'none'
        toggle.textContent = '▶'
    }
}

// ========== SOLICITUD DE CRUCERO Y COTIZACIONES ==========

function renderSolicitudCrucero(leadId) {
    const { leads, historico } = store
    const l = leads.find(x => x.id === leadId) || historico.find(x => x.id === leadId)
    if (!l || !l.solicitudCrucero) return ''

    const s = l.solicitudCrucero
    return `
        <div class="comentarios-section" style="margin-top:12px;padding-top:12px;border-top:1px solid var(--border);">
            <div class="comentarios-header" onclick="toggleSolicitudPanel()">
                <h4>🚢 Solicitud de Crucero</h4>
                <span id="solicitudToggle">▼</span>
            </div>
            <div id="solicitudContent" style="display:block;">
                <div style="background:var(--bg-2);border-radius:10px;padding:12px;font-size:12px;">
                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
                        ${s.puertos?.length ? `<div><span style="color:var(--text-3);">📍 Puerto:</span> ${s.puertos.join(', ')}</div>` : ''}
                        ${s.destinos?.length ? `<div><span style="color:var(--text-3);">🗺️ Destino:</span> ${s.destinos.join(', ')}</div>` : ''}
                        ${s.duracion ? `<div><span style="color:var(--text-3);">🌙 Duración:</span> ${s.duracion}</div>` : ''}
                        ${s.conQuien ? `<div><span style="color:var(--text-3);">👥 Con:</span> ${s.conQuien}</div>` : ''}
                        ${s.experiencia ? `<div><span style="color:var(--text-3);">✨ Experiencia:</span> ${s.experiencia}</div>` : ''}
                        ${s.naviera ? `<div><span style="color:var(--text-3);">🚢 Naviera:</span> ${s.naviera}</div>` : ''}
                        ${s.fechaDeseada ? `<div><span style="color:var(--text-3);">📅 Fecha:</span> ${s.fechaDeseada}</div>` : ''}
                        ${s.numPersonas ? `<div><span style="color:var(--text-3);">👥 Personas:</span> ${s.numPersonas}</div>` : ''}
                        ${s.presupuesto ? `<div><span style="color:var(--text-3);">💰 Presupuesto:</span> ${s.presupuesto}</div>` : ''}
                        ${s.residente && s.residente !== 'No' ? `<div><span style="color:var(--text-3);">🏠 Residente:</span> ${s.residente}</div>` : ''}
                    </div>
                    ${s.edadesMenores ? `<div style="margin-top:8px;"><span style="color:var(--text-3);">👶 Menores:</span> ${s.edadesMenores}</div>` : ''}
                    ${s.distribucionCabinas ? `<div style="margin-top:8px;"><span style="color:var(--text-3);">🛏️ Cabinas:</span> ${s.distribucionCabinas}</div>` : ''}
                    ${s.notas ? `<div style="margin-top:8px;padding-top:8px;border-top:1px solid var(--border);"><span style="color:var(--text-3);">📝 Notas:</span><br>${s.notas}</div>` : ''}
                    <div style="margin-top:8px;font-size:10px;color:var(--text-3);">Solicitado: ${s.fechaSolicitud ? window.fmtDate(s.fechaSolicitud) : 'N/A'}</div>
                </div>
            </div>
        </div>
    `
}

function toggleSolicitudPanel() {
    const content = document.getElementById('solicitudContent')
    const toggle = document.getElementById('solicitudToggle')
    if (content.style.display === 'none') {
        content.style.display = 'block'
        toggle.textContent = '▼'
    } else {
        content.style.display = 'none'
        toggle.textContent = '▶'
    }
}

function renderCotizaciones(leadId) {
    const { leads, historico } = store
    const l = leads.find(x => x.id === leadId) || historico.find(x => x.id === leadId)
    if (!l) return ''

    // Solo mostrar si tiene solicitud de crucero o cotizaciones existentes
    if (!l.solicitudCrucero && (!l.cotizaciones || l.cotizaciones.length === 0)) return ''

    const cotizaciones = l.cotizaciones || []
    const aprobada = cotizaciones.find(c => c.estado === 'aprobada')

    return `
        <div class="comentarios-section" style="margin-top:12px;padding-top:12px;border-top:1px solid var(--border);">
            <div class="comentarios-header" onclick="toggleCotizacionesPanel()">
                <h4>📋 Cotizaciones (${cotizaciones.length})${l.reCotizaciones > 0 ? ` <span style="font-size:10px;color:var(--text-3);">Re-cotizaciones: ${l.reCotizaciones}/2</span>` : ''}</h4>
                <span id="cotizacionesToggle">▼</span>
            </div>
            <div id="cotizacionesContent" style="display:block;">
                <div style="max-height:300px;overflow-y:auto;margin-bottom:10px;">
                    ${cotizaciones.length ? cotizaciones.map((c, i) => `
                        <div style="background:var(--bg-2);border-radius:10px;padding:12px;margin-bottom:8px;border-left:3px solid ${c.estado === 'aprobada' ? 'var(--green)' : (c.estado === 'enviada' ? 'var(--purple)' : 'var(--border)')};">
                            <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:6px;">
                                <div style="font-weight:600;font-size:13px;">#${i + 1} ${c.naviera || 'Sin naviera'}</div>
                                <span style="font-size:10px;padding:2px 8px;border-radius:10px;background:${c.estado === 'aprobada' ? 'rgba(16,185,129,0.2)' : (c.estado === 'enviada' ? 'rgba(107,78,255,0.2)' : 'var(--border)')};color:${c.estado === 'aprobada' ? 'var(--green)' : (c.estado === 'enviada' ? 'var(--purple-light)' : 'var(--text-2)')};">
                                    ${c.estado === 'aprobada' ? '✓ Aprobada' : (c.estado === 'enviada' ? '📤 Enviada' : '📝 Borrador')}
                                </span>
                            </div>
                            ${c.itinerario ? `<div style="font-size:12px;color:var(--text-1);margin-bottom:4px;">${c.itinerario}</div>` : ''}
                            <div style="font-size:11px;color:var(--text-2);">
                                ${c.fechas || ''} ${c.cabina ? '• ' + c.cabina : ''}
                            </div>
                            ${c.precio ? `<div style="font-size:16px;font-weight:600;color:var(--green);margin-top:6px;">${window.fmt(c.precio)}</div>` : ''}

                            ${c.estado !== 'aprobada' ? `
                            <div style="display:flex;gap:6px;margin-top:8px;padding-top:8px;border-top:1px solid var(--border);">
                                ${c.estado === 'borrador' ? `<button class="btn btn-xs btn-secondary" onclick="marcarCotizacionEnviada('${leadId}', '${c.id}')">📤 Marcar Enviada</button>` : ''}
                                ${c.estado === 'enviada' ? `<button class="btn btn-xs btn-primary" onclick="aprobarCotizacion('${leadId}', '${c.id}')">✓ Aprobar</button>` : ''}
                                <button class="btn btn-xs btn-ghost" onclick="editarCotizacion('${leadId}', '${c.id}')">✏️</button>
                                <button class="btn btn-xs btn-ghost" onclick="eliminarCotizacion('${leadId}', '${c.id}')" style="color:var(--red);">🗑️</button>
                            </div>
                            ` : ''}
                        </div>
                    `).join('') : '<div style="text-align:center;padding:16px;color:var(--text-2);font-size:12px;">Sin cotizaciones aún</div>'}
                </div>
                ${!aprobada ? `<button class="btn btn-sm btn-secondary btn-block" onclick="nuevaCotizacion('${leadId}')">+ Agregar Cotización</button>` : ''}
            </div>
        </div>
    `
}

function toggleCotizacionesPanel() {
    const content = document.getElementById('cotizacionesContent')
    const toggle = document.getElementById('cotizacionesToggle')
    if (content.style.display === 'none') {
        content.style.display = 'block'
        toggle.textContent = '▼'
    } else {
        content.style.display = 'none'
        toggle.textContent = '▶'
    }
}

function nuevaCotizacion(leadId) {
    const { leads } = store
    const l = leads.find(x => x.id === leadId)
    if (!l) return

    // Verificar límite de re-cotizaciones
    const cotizacionesEnviadas = (l.cotizaciones || []).filter(c => c.estado === 'enviada' || c.estado === 'aprobada').length
    if (cotizacionesEnviadas >= 3 && (l.reCotizaciones || 0) >= 2) {
        if (!confirm('Este cliente ya usó sus 2 re-cotizaciones gratuitas. ¿Se le cobrará $25 USD por esta cotización adicional. ¿Continuar?')) {
            return
        }
        l.reCotizaciones = (l.reCotizaciones || 0) + 1
    }

    const cotizacion = {
        id: 'cot_' + Date.now(),
        naviera: '',
        itinerario: '',
        fechas: '',
        cabina: '',
        precio: 0,
        estado: 'borrador',
        fechaCreacion: new Date().toISOString()
    }

    // Mostrar modal de edición
    editarCotizacionModal(leadId, cotizacion, true)
}

function editarCotizacion(leadId, cotId) {
    const { leads } = store
    const l = leads.find(x => x.id === leadId)
    if (!l) return

    const cotizacion = (l.cotizaciones || []).find(c => c.id === cotId)
    if (!cotizacion) return

    editarCotizacionModal(leadId, cotizacion, false)
}

function editarCotizacionModal(leadId, cotizacion, isNew) {
    const modalHTML = `
        <div id="cotizacionModal" style="position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.7);z-index:10000;display:flex;align-items:center;justify-content:center;padding:20px;">
            <div style="background:var(--bg-1);border-radius:16px;width:100%;max-width:500px;max-height:90vh;overflow-y:auto;">
                <div style="padding:20px;border-bottom:1px solid var(--border);">
                    <h3 style="margin:0;">${isNew ? '➕ Nueva Cotización' : '✏️ Editar Cotización'}</h3>
                </div>
                <div style="padding:20px;">
                    <div class="form-group">
                        <label class="form-label">Naviera</label>
                        <select id="cotNaviera" class="form-select">
                            <option value="">Seleccionar...</option>
                            <option value="Disney Cruise Line" ${cotizacion.naviera === 'Disney Cruise Line' ? 'selected' : ''}>Disney Cruise Line</option>
                            <option value="Royal Caribbean" ${cotizacion.naviera === 'Royal Caribbean' ? 'selected' : ''}>Royal Caribbean</option>
                            <option value="MSC Cruises" ${cotizacion.naviera === 'MSC Cruises' ? 'selected' : ''}>MSC Cruises</option>
                            <option value="Norwegian" ${cotizacion.naviera === 'Norwegian' ? 'selected' : ''}>Norwegian</option>
                            <option value="Celebrity Cruises" ${cotizacion.naviera === 'Celebrity Cruises' ? 'selected' : ''}>Celebrity Cruises</option>
                            <option value="Carnival" ${cotizacion.naviera === 'Carnival' ? 'selected' : ''}>Carnival</option>
                            <option value="Virgin Voyages" ${cotizacion.naviera === 'Virgin Voyages' ? 'selected' : ''}>Virgin Voyages</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Itinerario</label>
                        <input type="text" id="cotItinerario" class="form-input" placeholder="Ej: 7 noches Caribe Oriental" value="${cotizacion.itinerario || ''}">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Fechas</label>
                        <input type="text" id="cotFechas" class="form-input" placeholder="Ej: 15-22 Jun 2026" value="${cotizacion.fechas || ''}">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Tipo de Cabina</label>
                        <input type="text" id="cotCabina" class="form-input" placeholder="Ej: Balcón familiar" value="${cotizacion.cabina || ''}">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Precio Total (USD)</label>
                        <input type="number" id="cotPrecio" class="form-input" placeholder="3500" value="${cotizacion.precio || ''}">
                    </div>
                </div>
                <div style="padding:20px;border-top:1px solid var(--border);display:flex;gap:10px;justify-content:flex-end;">
                    <button class="btn btn-secondary" onclick="document.getElementById('cotizacionModal').remove()">Cancelar</button>
                    <button class="btn btn-primary" onclick="guardarCotizacion('${leadId}', '${cotizacion.id}', ${isNew})">Guardar</button>
                </div>
            </div>
        </div>
    `
    document.body.insertAdjacentHTML('beforeend', modalHTML)
}

function guardarCotizacion(leadId, cotId, isNew) {
    const { leads } = store
    const l = leads.find(x => x.id === leadId)
    if (!l) return

    const cotizacion = {
        id: cotId,
        naviera: document.getElementById('cotNaviera').value,
        itinerario: document.getElementById('cotItinerario').value,
        fechas: document.getElementById('cotFechas').value,
        cabina: document.getElementById('cotCabina').value,
        precio: parseFloat(document.getElementById('cotPrecio').value) || 0,
        estado: 'borrador',
        fechaCreacion: new Date().toISOString()
    }

    if (!l.cotizaciones) l.cotizaciones = []

    if (isNew) {
        l.cotizaciones.push(cotizacion)
    } else {
        const idx = l.cotizaciones.findIndex(c => c.id === cotId)
        if (idx >= 0) {
            cotizacion.estado = l.cotizaciones[idx].estado
            l.cotizaciones[idx] = cotizacion
        }
    }

    window.syncLeadToSupabase(l)
    document.getElementById('cotizacionModal').remove()
    window.openLead(leadId)
}

function marcarCotizacionEnviada(leadId, cotId) {
    const { leads } = store
    const l = leads.find(x => x.id === leadId)
    if (!l) return

    const cot = (l.cotizaciones || []).find(c => c.id === cotId)
    if (cot) {
        cot.estado = 'enviada'
        cot.fechaEnviada = new Date().toISOString()

        // Si es la primera cotización enviada, cambiar etapa del lead
        if (l.stage === 'cotizacion_solicitada') {
            l.stage = 'cotizacion'
        }

        window.syncLeadToSupabase(l)
        window.renderAll()
        window.openLead(leadId)
    }
}

function aprobarCotizacion(leadId, cotId) {
    const { leads, settings } = store
    const l = leads.find(x => x.id === leadId)
    if (!l) return

    const cot = (l.cotizaciones || []).find(c => c.id === cotId)
    if (cot) {
        cot.estado = 'aprobada'
        cot.fechaAprobada = new Date().toISOString()

        // Actualizar lead con datos del crucero aprobado
        if (cot.naviera) l.destination = cot.naviera + (cot.itinerario ? ' - ' + cot.itinerario : '')
        if (cot.precio) {
            l.totalVenta = cot.precio
            l.commission = parseFloat((cot.precio * 0.10).toFixed(2))
            l.commission70 = parseFloat((l.commission * ((settings.comisionM2M || 70) / 100)).toFixed(2))
        }
        l.platform = cot.naviera
        l.type = 'crucero'

        // Parsear fechas del crucero si están en formato "15-22 Jun 2026"
        if (cot.fechas) {
            const fechaMatch = cot.fechas.match(/(\d{1,2})[-–](\d{1,2})\s+(\w+)\s+(\d{4})/)
            if (fechaMatch) {
                const meses = {ene:0,feb:1,mar:2,abr:3,may:4,jun:5,jul:6,ago:7,sep:8,oct:9,nov:10,dic:11,
                              jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11}
                const mes = meses[fechaMatch[3].toLowerCase().substring(0,3)]
                if (mes !== undefined) {
                    const sd = new Date(fechaMatch[4], mes, fechaMatch[1])
                    const ed = new Date(fechaMatch[4], mes, fechaMatch[2])
                    if (!isNaN(sd.getTime())) l.travelDate = sd.toISOString()
                    if (!isNaN(ed.getTime())) l.travelEnd = ed.toISOString()
                }
            }
        }

        // Cambiar etapa
        l.stage = 'prereserva'

        window.syncLeadToSupabase(l)
        window.renderAll()
        window.openLead(leadId)

        window.toast('✅ ¡Cotización aprobada! Lead actualizado con datos del crucero.')
    }
}

function eliminarCotizacion(leadId, cotId) {
    if (!confirm('¿Eliminar esta cotización?')) return

    const { leads } = store
    const l = leads.find(x => x.id === leadId)
    if (!l || !l.cotizaciones) return

    l.cotizaciones = l.cotizaciones.filter(c => c.id !== cotId)
    window.syncLeadToSupabase(l)
    window.openLead(leadId)
}

// Función para importar leads del formulario público
function importarLeadsFormulario() {
    const { leads, historico, clients } = store
    const stored = localStorage.getItem('m2m_form_submissions')
    if (!stored) return 0

    try {
        const submissions = JSON.parse(stored)
        if (!submissions.length) return 0

        let imported = 0
        submissions.forEach(sub => {
            // Verificar si ya existe por teléfono
            const exists = leads.find(l => l.phone === sub.phone) || historico.find(h => h.phone === sub.phone)
            if (exists) return

            // Crear cliente
            const clientKey = sub.phone || 'lead_' + sub.id
            if (!clients[clientKey]) {
                clients[clientKey] = {
                    titular: sub.titular,
                    contacto: sub.contacto,
                    phone: sub.phone,
                    email: sub.email,
                    referido: null,
                    canalAlerta: 'whatsapp',
                    trips: [],
                    createdAt: sub.createdAt
                }
            }

            // Asignar clientKey
            sub.clientKey = clientKey

            // Agregar a leads
            leads.push(sub)
            imported++
        })

        if (imported > 0) {
            // Limpiar submissions procesadas
            localStorage.removeItem('m2m_form_submissions')
            window.saveData()
            window.renderAll()
            window.toast(`📥 ${imported} lead(s) importado(s) del formulario`)
        }

        return imported
    } catch (e) {
        console.error('Error importando leads:', e)
        return 0
    }
}

// Verificar leads del formulario cada 10 segundos
// Track intervals so they can be cleaned up if needed
const _calTimers = []
_calTimers.push(setInterval(importarLeadsFormulario, 10000))

// Refresh "Activos Ahora" count every 30s (active window shifts with time)
_calTimers.push(setInterval(() => {
    const { formSessionsLoaded, allFormSessions } = store
    if (!formSessionsLoaded || !document.getElementById('formulariosView')?.classList.contains('active')) return
    const fiveMinAgo = new Date(Date.now() - 5 * 60 * 1000)
    const activeCount = allFormSessions.filter(s => !s.completed && new Date(s.last_activity) >= fiveMinAgo).length
    const el = document.getElementById('formActiveNow')
    if (el) el.innerHTML = (activeCount > 0 ? '<span class="form-active-dot"></span>' : '') + activeCount
}, 30000))

// Storage event for detecting form changes — add only once
function _onStorageFormChange(e) {
    if (e.key === 'm2m_form_submissions' && e.newValue) {
        console.log('Nuevo lead detectado vía storage event')
        setTimeout(importarLeadsFormulario, 500)
    }
}
if (!window._calStorageListenerAdded) {
    window.addEventListener('storage', _onStorageFormChange)
    window._calStorageListenerAdded = true
}

Object.assign(window, {
    calNavMonth, calGoToday, getCalendarEvents, renderCalendario,
    openCalPicker, calPickerYearNav, renderCalPickerMonths, selectCalMonth,
    showDayEvents, viewLeadFromEvent, sendWhatsApp, sendEmail,
    getPlantillaCategoriaFromEvent, buildMensajeDatos,
    addToGoogleCal, generateGoogleCalLink,
    setupUploadZone, exportToExcel,
    loadTareas, saveTareas, updateTareasBadge, renderTareas,
    openNewTareaModal, editTarea, saveTarea, toggleTarea, deleteTarea,
    renderComentarios, toggleComentarios, agregarComentario,
    getTareasForLead, renderTareasEnPanel, toggleTareasPanel,
    renderSolicitudCrucero, toggleSolicitudPanel,
    renderCotizaciones, toggleCotizacionesPanel,
    nuevaCotizacion, editarCotizacion, editarCotizacionModal,
    guardarCotizacion, marcarCotizacionEnviada, aprobarCotizacion, eliminarCotizacion,
    importarLeadsFormulario,
})
